<div
  class="filter-pill__container"
  [matTooltip]="pillTooltip"
  [matTooltipClass]="'filter-pill__tooltip'"
>
  <div class="filter-pill">
    <div class="filter-pill__left-side">
      <div class="filter-pill__icon-background">
        <xi-icon [icon]="pillIcon" contrast="high" iconSize="small"></xi-icon>
      </div>
    </div>

    <div class="filter-pill__content">
      <div *appMiddleEllipsize="pillText; hideTooltip: true"></div>
    </div>

    <div *transloco="let t" class="filter-pill__right-side">
      @if (!isReadOnly) {
        <xi-dropdown
          [data]="filterOptions"
          select="single"
          type="icon"
          color="orca"
          [internalProps]="{ iconButton: { icon: 'settings' } }"
          (onValueChange)="onPillAction($event.detail.selected.id)"
        ></xi-dropdown>
      }
    </div>
  </div>
</div>
